const stopPaysEmpty = {
    title: 'Ошибка отката',
    description: 'В системе <b>нет платежей</b>,<br/>отправленных на подпись исполнителям',
    buttonText: 'Понятно',
    mode: 'denied',
} as const;

export default stopPaysEmpty;
